import { CardColor } from '@/api/workspaceSettings/queries';
import { Activity, Subtask, Task } from '../../types';

const nullPrioValues: any = {
    basicPrioValue: null,
    businessValue: null,
    effort: null,
    kanoPrioValue: null,
    moscowPrioValue: null,
};

export const createSubtaskFromTask = (
    sourceTask: Task,
    parentTask: Task,
    releaseId: string,
    order: number,
    defaultTaskColor: CardColor,
    defaultSubtaskColor: CardColor
): Subtask => {
    return {
        ...sourceTask,
        activityId: parentTask.activityId,
        taskId: parentTask.id,
        releaseId: releaseId,
        order: order,
        ...nullPrioValues,
        color: sourceTask.color == defaultTaskColor ? defaultSubtaskColor : sourceTask.color,
    };
};

export const createSubtaskFromActivity = (
    sourceActivity: Activity,
    parentTask: Task,
    releaseId: string,
    order: number,
    defaultActivityColor: CardColor,
    defaultSubtaskColor: CardColor
): Subtask => {
    const subtask = {
        ...sourceActivity,
        activityId: parentTask.activityId,
        taskId: parentTask.id,
        releaseId: releaseId,
        order: order,
        ...nullPrioValues,
    };

    subtask.color = sourceActivity.color == defaultActivityColor ? defaultSubtaskColor : sourceActivity.color;

    delete subtask.isCollapsed;

    return subtask;
};

export const createTaskFromActivity = (
    sourceActivity: Activity,
    parentActivity: Activity,
    order: number,
    defaultActivityColor: CardColor,
    defaultTaskColor: CardColor
): Task => {
    const task = {
        ...sourceActivity,
        activityId: parentActivity.id,
        order: order,
        color: sourceActivity.color == defaultActivityColor ? defaultTaskColor : sourceActivity.color,
    };

    delete task.isCollapsed;

    return task;
};

export const createTaskFromSubtask = (
    sourceSubtask: Subtask,
    parentActivity: Activity,
    order: number,
    defaultSubtaskColor: CardColor,
    defaultTaskColor: CardColor
): Task => {
    const task = {
        ...sourceSubtask,
        activityId: parentActivity.id,
        order: order,
    };
    task.color = sourceSubtask.color == defaultSubtaskColor ? defaultTaskColor : sourceSubtask.color;

    delete task.taskId;
    delete task.releaseId;

    return task;
};

export const createActivityFromTask = (
    sourceTask: Task,
    order: number,
    defaultTaskColor: CardColor,
    defaultActivityColor: CardColor
): Activity => {
    const activity = {
        ...sourceTask,
        isCollapsed: false,
        order: order,
    };
    activity.color = sourceTask.color == defaultTaskColor ? defaultActivityColor : sourceTask.color;

    delete activity.activityId;

    return activity;
};

export const createActivityFromSubtask = (
    sourceSubtask: Subtask,
    order: number,
    defaultSubtaskColor: CardColor,
    defaultActivityColor: CardColor
): Activity => {
    const activity = {
        ...sourceSubtask,
        isCollapsed: false,
        order: order,
    };
    activity.color = sourceSubtask.color == defaultSubtaskColor ? defaultActivityColor : sourceSubtask.color;

    delete activity.activityId;
    delete activity.taskId;
    delete activity.releaseId;

    return activity;
};
